import React from 'react';
import metlifeLogo from '../utilities/images/Metlife_logo.png';

const Header = () => {
    return (
        <>            
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center',height: '3rem', padding: '0.5rem', backgroundColor: 'white'}}>
            <img style={{alignContent:"left"}} src={metlifeLogo} alt="Metlife" />
            
        </div>
        </>
    );
};

export default Header;